<template>
    <div style="background:white" class="ve-list-page">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <div style="width:60px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" style="margin-top:0px;"><span style="font-size:13px; ">{{ $LANG('0138', '新增') }} </span></el-link>
                </div>
  
                <span style=" margin-left:20px;font-size:12px;margin-right:10px;">{{ $LANG('0681', '字段查询') }}</span>
                <el-select v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" filterable  style="width:150px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="queryEvent('N')" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="queryEvent('N')" ></el-button>
                </el-input> 
                <el-select v-model="selparam2" size="small" :placeholder="$LANG('1675', '请选择列名')" filterable  style="width:150px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam2" @keyup.enter.native="queryEvent('N')" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="queryEvent('N')" ></el-button>
                </el-input>
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="dropSel('fldset')" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div>
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
            :table-data="poData"
            :columnHiddenOption="columnHiddenOption"
            :border-around="true"
            :border-x="true"
            :border-y="true"
            :fixed-header="true"
            row-key-field-name="IDSEQ"
            :row-style-option="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :max-height="subHeight"
            :virtual-scroll-option="virtualScrollOption"
            :scroll-width="0"
            :column-width-resize-option="columnWidthResizeOption"
            :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            :cellSelectionOption="{enable: false}"
            v-loading="loading"
            :element-loading-text="$LANG('1959', '加载中')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            id="smp_stkin_load"
            ref="tableRef">
        </ve-table>
        </div>
        <!-- 分页查询 -->
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px" class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>
        </el-dialog>
        <!-- 字段设置 -->
        <el-dialog class="pub_dialog" v-dialogDrag  v-if="setWin" :visible.sync="setWin" width="480px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">字段显示设置</span>
            </div>
            <easy-win v-bind:colArr ="fldArr" @child-exit="setWin=false" @child-sure="setOk"></easy-win>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="poRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in tabCol" :key="index" >
                        <FormItem   :label="$translate.getColTitle(item, $store.state.lang)"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >
                            <el-date-picker size="small" :disabled="saveFlag||item.disabled==='Y'" type="date"  v-if="item.edcss==='date'" v-model="poRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="small" :disabled="saveFlag||item.disabled==='Y'" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="poRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-checkbox v-else-if="item.edcss=='checkbox'"  true-label="Y" false-label="N" v-model="poRow[item.key]"></el-checkbox>
                            
                            <el-select size="small" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="poRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input size="small" :placeholder="item.holder" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="poRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div class="one-div"><span class="oneRow">{{ $LANG('0109', '明细资料') }}</span>
                    <i class="iconfont icon-xinzeng" style="color:#cc0000;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool||saveFlag" @click="dtlAdd" :underline="false" style="color:#cc0000;white-space:nowrap"><span style="font-size:12px;margin-right:15px;white-space:nowrap">{{ $LANG('0087', '新增明细') }}</span></el-link>
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    class="custom-table-border"
                    :height="dtlHeight" 
                    :row-key="getDtlKey"
                    :row-class-name="tabRowClass"
                    cell-class-name="clearPadding"
                    style="margin-top:-8px"
                    @row-click="rowClick"
                    :cell-style="{padding:'2px'}"
                    ref="refdtl"
                    highlight-current-row > 
                    <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"></el-table-column>
                    <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N')" :key="index" 
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                        :min-width="item.width">
                        <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>
                        <template slot-scope="scope">
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else-if="item.key=='DEPTNO'" v-text="scope.row['DEPTNM']"> </span>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >                    
                                <el-select size="mini" v-if="item.key=='DEPTNO'" @change="deptChg(scope.row)" v-model="scope.row[item.key]">
                                    <el-option v-for="(item,index) in deptArr" :label="item.CNAME" :value="item.CODE" :key="index"></el-option>
                                </el-select>
                                <el-input   @focus="inputBtn(scope.row,scope.$index,item.key)" :ref="'pos'+scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>  
                                <el-input type="number" @input="qtyPrc(scope.row,scope.$index,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <el-date-picker :disabled="item.disabled=='N'?false:true"  :ref="'pos'+scope.$index+item.key" type="date" size="mini" v-else-if="item.edcss==='date'" v-model="scope.row[item.key]" :clearable="false" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  
                                <el-checkbox :disabled="item.disabled=='N'?false:true" true-label="Y" false-label="N" :ref="'pos'+scope.$index+item.key"   v-else-if="item.edcss=='checkbox'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-checkbox> 
                                <el-input  @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                            </span>
                        </template> 
                    </el-table-column>    
                 
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="70">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="saveFlag" @click="dtlDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px; ">{{ $LANG('0131', '删除') }}</span></el-link>
  
                        </template>
                    </el-table-column>  
                </el-table>
 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <i class="web-font" style="font-size:14px;margin-right:20px;color:#ed4014;font-weight:600">{{ $LANG('1497', '提示：订单审核后不能再编辑 ， 如需编辑请弃审') }}</i>
                    <span style="margin-right:30px">
                        <i v-if="poRow['STFG']==='N'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                        <i v-else-if="poRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                        <i v-else-if="poRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                    </span>
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="addBool||saveFlag"  type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
         <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import pubWin from '../datamgt/pubwin.vue'  
import repWin from '../datamgt/repWin.vue' 
import easyWin from '../datamgt/easy_field.vue'
export default {
    name:'sample_stkin',
    data () {
        return {
     
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            toolFlag:false,
            qryCond:'',
            prodCol:[],
            dtlRow:{},
            v_tabRow:{},
            v_tabIndex:'',
            chkIndex: 0,
            stfgBool:true,
            appBool:false,
            v_commit :true,
            promptWin:false,
   
            dtlFlag:'create',
            prdRow:{},
            supFlag:'',
            addFlag:'create',
            v_admin:this.$cookies.get('v_admin') , 
            rowDtl:{},
            btnWin:false,
            delDtlArr:[],
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容') + '...',
            ruleValidate:{},
            selparam:'IDNO',
            txtparam:'',
            poRow:{},
            prdFlag:'create',
            goPage:'',
            rowIdseq:'',
            poData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
   
            loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径   
            pageList: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            selparam2:'',
            txtparam2:'',
            oper2:'like',
            dataCount:0,
            rowSize:50,
            dtlCol:[],
            matCol:[],
            tabCol:[],
            vueCol:[],
            setWin:false,
            fldArr:[],
            loadWin:false,
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            columnWidthResizeOption: {
                enable: true, // default false
                minWidth: 20, // column resize min width
                // column size change
                sizeChange: ({ column, differWidth, columnWidth }) => {
                    const targetCol =this.vueCol.find(item=>item.key==column.key)
                    if (targetCol){
                        targetCol.width =columnWidth
                    }
                },
            },
            rowStyleOption: {
                clickHighlight: true,
            },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            v_inputrow:{},
            v_row:{},
            v_sort:'asc',
            virtualScrollOption: { enable: false },
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            v_key:'',
            v_idseq:this.$cookies.get('idseq'),
            dtlIndex:'',
            comboArr:[],
            v_index:0,
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            repWin:false,
            repUrl:'',
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            deptArr:[],
        }
    },
    components: {
      pubWin,  
      repWin,
      easyWin,
   
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 162) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 240) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
    },
    mounted () {
        this.showkey()
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        }) 
        getBaseData(this.v_url,'CORPID',this.v_corpid ,'','','v_HR_DEPT','').then(res=>{
            this.deptArr =res.result
        })
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','430443','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','430443','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISEXP==='N'){ //确认
                    this.appBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','430443','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getPoList('') //询价单主数据   
            this.comSelect() 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        qtyPrc(row,index,key){    
         
        },
        dropSel(val){
            if (val =='sendRep'){ //分发
                this.repWin =true
                this.repUrl =this.$store.state.repUrl+  'file_send.cpt' +'&p_corpid='+ this.v_corpid

            }else if (val=='backRep'){ //回收
                this.repWin =true
                this.repUrl =this.$store.state.repUrl+  'file_back.cpt' +'&p_corpid='+ this.v_corpid
            }else if (val =='fldset'){  //字段设置显示--隐藏
                this.fldArr =[]
                getTabColOrData(this.v_url ,'V_USER_FLDSET','idseq','430443-1','userno',this.v_username,'','',' order by sortby').then((res) => {
                    let v_setArr =res.result
                    //预处理：将 v_setArr中所有的FLDNO提取出来，转为大写，存入 Set
                    const existFldnos =new Set()
                    v_setArr.forEach(item=>existFldnos.add(item.FLDNO.toUpperCase()))
                    // 遍历 vueCol, 检查是否存在
                    this.vueCol.forEach(item =>{
                        const keyUpper = (item.key||'').toUpperCase()
                        if (!existFldnos.has(keyUpper)){
                            let v_obj ={'IDSEQ':'430443-1',LSTSEQ:'',COLWIDTH:item.width,CORPID:this.v_corpid,USERNO:this.v_username,FLDNO:item.key,FLDNM:item.title, 'VISFLAG':'Y'}
                            v_setArr.push(v_obj)
                            // 同时也添加到 Set 中，防止 vueCol 中有重复的 key 导致重复添加
                            existFldnos.add(keyUpper)
                        }
                    })
                    //构建Map,源数组 : key ---> COLWIDTH
                    const widthMap =new Map(this.vueCol.map(item=>[item.key,item.width]))
                    //遍历目标数组并更新
                    let updateColumns =v_setArr.map(col =>{
                        if (widthMap.has(col.FLDNO)){
                            return {...col ,COLWIDTH:widthMap.get(col.FLDNO)}
                        }
                        return col
                    })
                    this.fldArr =[...updateColumns]
                })
                this.setWin =true
            }
        },
        getSetList(){
            getTabColOrData(this.v_url, 'V_USER_FLDSET','idseq','430443-1','userno',this.v_username,'','',' order by sortby').then((res) => {
                let v_data =res.result
                if (v_data && v_data.length>0) { // 有用户个性化记录
                    let v_arr=[]
                    this.columnHiddenOption['defaultHiddenColumnKeys'] =[]
                    // 1、隐藏 ，2、列宽 3、排序
                    v_data.forEach(item=>{
                        if (item['VISFLAG'] =='N') {
                            this.columnHiddenOption['defaultHiddenColumnKeys'].push(item['FLDNO'])
                        }else{
                            v_arr.push(item['FLDNO'])
                        }
                    })
                    this.$refs["tableRef"].showColumnsByKeys(v_arr)
                    this.$refs["tableRef"].hideColumnsByKeys(this.columnHiddenOption['defaultHiddenColumnKeys'])
                    //1.1 构建 Map : key -> {width,sortby,isfix} ,使用 Map 提高查找效率
                    const configMap =new Map() //建立索引映射
                    v_data.forEach(item =>{
                        configMap.set(item['FLDNO'],{COLWIDTH:item.COLWIDTH,SORTBY:item.SORTBY,ISFIX:item['ISFIX']})
                    })
                    //console.log(JSON.stringify(configMap))
                    //1.2 遍历 vueCol ,同步 width 宽度 与 冻结 fixed
                    this.vueCol.forEach(col =>{
                        const  targetCol= configMap.get(col['key'])
                        if (targetCol){
                            col.width =targetCol['COLWIDTH']
                            col.fixed =targetCol['ISFIX']=='Y'?"left":targetCol['ISFIX']=='R'?"right":false
                        }
                    })
                    //1.3 根据个性化的 SORTBY排序 来更新
                    this.vueCol.sort((a,b)=>{
                        const targetA =configMap.get(a['key'])
                        const targetB =configMap.get(b['key'])
                        const sortA = (targetA  && targetA.SORTBY!==undefined)?targetA.SORTBY:9999
                        const sortB = (targetB  && targetB.SORTBY!==undefined)?targetB.SORTBY:9999
                        return sortA - sortB
                    })
                }
            })
        },
        setOk(v_obj){
            v_obj.forEach((item,index)=>item['SORTBY']=index+1)
            this.loadWin =true
            this.$axios({
                method: 'post',
                url: 'xuper_auth/batDtlSave2' ,
                data: {p_json:JSON.stringify(v_obj), p_table:'USER_FLDSET',p_idseq:'430443-1', p_action:'S' },
            }).then(res=>{
                if (res.code=='200') {
                    this.getSetList()
                    this.setWin =false
                    this.loadWin =false
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                    this.loadWin =false
                }
            })
        },
        deptChg(row){
            row['EMPNO'] =''
            row['EMPNM'] =''
        },  
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        //表格行 按回车键 到下一行
        nextLine(key,val,reftab){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                    if (reftab=='refpos'){
                        v_count =this.dtlData.length
                    }
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                    if (reftab=='refpos'){
                        this.$refs['pos'+this.chkIndex+'JOBDESC'][0].focus()  
                    } 
                }else{
                    if (reftab=='refpos'){
                        let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox')
                        v_col.some((item,index)=>{
                            if (item.key==key){
                               this.$refs['pos'+this.chkIndex+ v_col[index+1].key][0].focus()  
                            }
                        })
                    }
                }
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1
                if (reftab=='refpos'){
                    if (this.chkIndex >=this.dtlData.length) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                }
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }              
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
            }                    
        },
        btnSure(obj){
            if (this.v_key =='MATNO'){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ MATNO:obj['IDNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],MATTYNM:obj['MATTYNM'],MATID:obj['IDSEQ']  } ))  
                this.$refs['pos'+ this.v_tabIndex+'QTY'][0].focus()  
                this.chkIndex =this.v_tabIndex
            } 
            this.btnWin =false
        },
        inputBtn(row,index, key){   
            this.v_key =key         
            if (key=='MATNO'){
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='v_bs_mat'
                this.tableCol =this.prodCol
                this.v_key2 ='modelno'
                this.v_value2 = 'SMP'
                this.btnWin =true
            }
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        // 明细 
        getDtlList(idseq ){
            this.dtlData=[]
            getTabColOrData(this.v_url,'V_SMP_STKdtl','idseq',idseq,'','','','',' ORDER BY lstseq' ).then((res) => { 
                this.dtlData =res.result 
            })
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.refdtl.doLayout();
            }) 
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'430443',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
 
        //明细编辑、删除
        dtlDel(row,index){
            this.delDtlArr.push(row)
            this.dtlData.splice(index,1 )
        },
 
        dtlAdd(){
 
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })
            v_row['ISCHK']='Y'
            this.dtlData.push(v_row)
            this.delDtlArr=[]
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            }) 
        },
 
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.v_index =index
            this.addFlag='edit'
            this.poRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
            this.rowIdseq=row.IDSEQ
            //明细
            this.getDtlList(row.IDSEQ)
            this.addWin=true   
            this.v_commit =true   
        },
        //保存记录
        saveRec(){
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.poRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit) { 
                let v_title=false  
                this.dtlData.forEach(item=>{
                    this.dtlCol.filter(item =>item.notnull=='Y').some(it =>{
                        if (!item[it.key]){
                            v_title =it['title']
                            return true
                        }
                    }) 
                })
                if (this.dtlData.length==0){
                    this.promptWin =true
                    this.prompt =this.$LANG('0109', '明细资料')+this.$LANG('2051', '不能为空')
                }else if ( v_title){
                    this.promptWin =true
                    this.prompt =v_title +this.$LANG('2051', '不能为空')
                }else{
                    this.v_commit =false
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.poRow,{CORPID:this.v_corpid })), p_table:'SMP_STK',frmid:'430443'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            let idseq_ =res.idseq
                            //1、明细保存：批量保存   
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'SMP_STKDTL',p_idseq:idseq_ , p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promtWin=true
                                    this.prompt=res.result
                                }else{
                                    this.getPoList('')
                                }
                            })
                            //明细删除
                            for (let k=0;k<this.delDtlArr.length;k++) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:idseq_,p_key2:'lstseq',p_value2:this.delDtlArr[k].LSTSEQ, p_table:'SMP_STKdtl', p_action:'D' },
                                })
                            }          
                            this.addWin =false   
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                }
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.poRow={DTTM:getDate('day'),'IDSEQ':'',STFG:'N',STKNO:'430459',IDTY:'STKIN'}
            this.dtlData=[]
            this.saveFlag=false
            this.v_commit =true
        },
 
        getRowKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        getDtlKey(row){
            return row.index
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        rowClick(row){
            this.chkIndex =row.index
        },
         //状态变更
        stfgRec(row,val,index,v_comm){
            let v_cond ='' ,v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser=''
            if (val =='K') {
                v_cfmdttm =getDate('full')
                v_cfmuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\',chkuser=null,chkdttm=null'
            }else if (val =='Y'){
                v_chkdttm =getDate('full')
                v_chkuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\''
            }
            this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗?'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'SMP_STK',p_cond: v_cond},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        if (val =='X'){
                            this.poData.splice(index,1)
                        } else{   
                            this.getPoList('')     
                            if (val =='Y'){
                                Object.assign(row,{STFGNM:v_comm ,STFG:val, CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                            }else{
                                Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm })
                            }
                        }
                    }    
                })
            }).catch(()=>{})           
        },
        //状态查询
        rowShow(){
            this.v_row = {}
            this.v_inputrow = {}
            this.current = 1
            this.queryEvent('N')
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },
        inputQry(){
            this.current =1
            this.queryEvent('N')
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            }
            this.vueCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.poData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 : a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 : b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 : nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        queryEvent(v_where){
            let v_cond ='' , v_oper='' ,v_edcss=''
            if (this.selparam){ //列1
                this.vueCol.some(item=>{
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (this.oper==='like'){
                    v_cond=v_cond+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                } else{
                    if (this.txtparam){
                        if (v_edcss=='number'){
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+ this.txtparam
                        }else {
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                        }
                    }
                }
            }
            if (this.selparam2){ //列2
                v_edcss =''
                this.vueCol.some(item=>{
                    if (item['key']==this.selparam2){
                        v_edcss =item['edcss']
                    }
                })
                if (this.oper2==='like'){
                    v_cond=v_cond+' and  '+this.selparam2+'  like  \'%' + this.txtparam2+'%\' '
                } else{
                    if (this.txtparam2){
                        if (v_edcss=='number'){
                            v_cond=v_cond+' and  '+this.selparam2  +this.oper2+ this.txtparam2
                        }else {
                            v_cond=v_cond+' and  '+this.selparam2  +this.oper2+' \''+this.txtparam2+'\' '
                        }
                    }
                }
            }
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.vueCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (!v_oper){
                        v_oper ='like'
                    }
                    if (v_oper =='like'){
                        v_cond =v_cond +' and upper('+item+')  like  upper(\'%'+ (this.v_row[item]).trim()+'%\')'
                    }else{
                        if (v_edcss =='number' ){
                            v_cond =v_cond +' and '+item+ v_oper + this.v_row[item]
                        }else if ( v_edcss=='date'){
                            v_cond =v_cond +' and substr('+item+',1,10)'+ v_oper +'\''+this.v_row[item] +'\''
                        }else{
                            v_cond =v_cond +' and  '+item +v_oper+'\''+ (this.v_row[item]).trim()+'\''
                        }
                    }
                }
            })
            if (v_where =='N'){
                this.getPoList(v_cond)
            }
        },
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert(this.$LANG('1721', '请输入跳至页数'), this.$LANG('1442', '提示'), {
                    confirmButtonText: this.$LANG('1638', '确定'),
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.poData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.poData = this.allList          
            }else{
         
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.poData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                const table = this.$refs.tableRef
                if (table && typeof table.setHighlightRow === 'function' && this.poData[this.v_index]) {
                    table.setHighlightRow({ rowKey: this.poData[this.v_index].IDSEQ })
                }
            })
        },
 
        //查询界面
        getPoList(p_cond){
            this.loading = true
            getTabColOrData(this.v_url,'V_SMP_STK','IDTY','STKIN','CORPID',this.v_corpid,'','',p_cond ).then((res) => {
                this.allList =res.result
                this.initPage() 
                this.loading = false
            })
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','430443','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                    const fieldRows =res.result
                    vm.tabCol = []
                    vm.vueCol = []
                    fieldRows.forEach(rowField => {
                        const itcol = rowField
                        const title =vm.$translate.getColTitle(itcol, vm.$store.state.lang)
                        vm.tabCol.push({
                            title,
                            key: itcol.key,
                            align: itcol.align,
                            width: itcol.width,
                            thide: itcol.THIDE,
                            fhide: itcol.FHIDE,
                            edcss: itcol.EDCSS,
                            disabled: itcol.DISABLED,
                            dotnum: itcol.DOTNUM,
                            holder: itcol.HOLDER,
                            sortable: itcol.SORTABLE,
                        })
                        if (itcol.THIDE=='N'){
                            vm.vueCol.push({
                                field: itcol.key,
                                key: itcol.key,
                                title,
                                type:itcol.EDCSS=='checkbox'?'check':itcol.EDCSS,
                                align: itcol.align,
                                width: Number(itcol.width),
                                thide: itcol.THIDE,
                                fhide: itcol.FHIDE,
                                edcss: itcol.EDCSS,
                                disabled: itcol.DISABLED,
                                sortable: false,
                                ellipsis: { showTitle: true },
                                renderHeaderCell: ({column}, h) => {
                                if (itcol.EDCSS =='number') {
                                    return (
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                            </div>
                                            <div style="display:flex">
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_row[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                    <option value="=">=</option>
                                                    <option value=">">&gt;</option>
                                                    <option value="<">&lt;</option>
                                                    <option value="!=">!=</option>
                                                </select>
                                                <el-input disabled={itcol.EDCSS=='image'} v-model={this.v_row[column.key]} on-change={()=>this.inputQry()} style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                            </div>
                                        </div>
                                    )
                                }else{
                                    if (itcol.EDCSS=='checkbox'){
                                        return (
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                                </div>
                                                <div style="display:flex">
                                                    <el-select size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]} on-change={()=>{this.inputQry()}}>
                                                        <el-option value="Y" label="是"></el-option>
                                                        <el-option value="N" label="否"></el-option>
                                                    </el-select>
                                                </div>
                                            </div>
                                        )
                                    }else {
                                        return (
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                                </div>
                                                <div style="display:flex">
                                                    <input disabled={itcol.EDCSS=='image'} v-model={this.v_row[column.key]} on-keyup={(event)=>{if (event.key=='Enter') this.inputQry()}} on-change={()=>this.inputQry()} style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></input>
                                                </div>
                                            </div>
                                        )
                                    }
                                }
                            },
                                renderBodyCell: ({row}) => {
                                    const rowVal = row[itcol.key]
                                    if (itcol.key === 'IDNO') {
                                        return <el-link underline={false} on-click={() => this.repBtn(row)}><div style="color:#409eff;border-bottom:1px solid red;font-size:12px">{rowVal}</div></el-link>
                                    }
                                    if (String(itcol.EDCSS || '').toLowerCase() === 'checkbox') {
                                        return <el-checkbox disabled true-label="Y" false-label="N" v-model={row[itcol.key]} style="width:100%">&nbsp;</el-checkbox>
                                    }
                                    return <span>{rowVal}</span>
                                },
                            })
                        }
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: '序号',
                        width: 55,
                        align: 'center',
                        fixed: 'left',
                        disableResizing: true,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                        renderHeaderCell: ({column}) => <div><div style="margin-top:3px">{column.title}</div><el-link on-click={this.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div>,
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0870', '操作'),
                        width: 210,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({row, rowIndex}) => (
                            <div style="white-space:nowrap">
                                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:2px"></i>
                                <el-link on-click={() => this.editRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                {row.STFG === 'N' ? <span>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:2px"></i>
                                    <el-link on-click={() => this.editRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                    <el-link disabled={this.cfmBool} on-click={() => this.stfgRec(row, 'Y', rowIndex, this.$LANG('0134', '审核'))} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0134', '审核')}</span></el-link>
                                    <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:2px"></i>
                                    <el-link on-click={() => this.stfgRec(row, 'X', rowIndex, this.$LANG('0257', '作废'))} underline={false}><span style="font-size:12px">{this.$LANG('0257', '作废')}</span></el-link>
                                </span> : null}
                                {row.STFG === 'Y' ? <span>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                    <el-link disabled={this.cfmBool} on-click={() => this.stfgRec(row, 'N', rowIndex, this.$LANG('0137', '弃审'))} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0137', '弃审')}</span></el-link>
                                </span> : null}
                            </div>
                        ),
                    })
                    vm.getSetList()
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','430443','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
 
        },
    }
}
</script>
<style scoped lang="less">
    .item-width  {
        height:20px;
        width: 32%;
        color:#409EFF;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .el-table__body tr.current-row > td {
        background-color: #F1e1ff !important;
    } 
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
